import globalIP from '@/GlobelIP';
import React, { useState } from 'react';
import { Button, Message, Modal, Radio, RadioGroup, toaster } from 'rsuite';

const ActiveInacitve = ({
  activeInModal,
  onClose,
  selectedRowIds,
  setSelectedRowIds,
  fetchData
}) => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('Active');
  const updateProduct = async () => {
    try {
      setLoading(true);
      for (const ids of selectedRowIds) {
        // ✅ Update the main product to set Authorized = "Inactive"
        const mainProductUpdateResponse = await fetch(`${globalIP}/api/catalogues/${ids}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              Status: status
            }
          })
        });
        if (mainProductUpdateResponse.ok) {
          console.log(`Product with ID ${ids} marked as ${status}.`);
        } else {
          console.error(`Failed to update main product with ID ${ids}.`);
        }

        // ✅ Update variant products to set Authorized = "Inactive"
      }
      setLoading(false);
      fetchData();
      setSelectedRowIds([]);
      onClose();
      toaster.push(
        <Message showIcon type="success">
          {selectedRowIds.length} Products Updated Successfully.
        </Message>,
        { placement: 'topEnd' }
      );
    } catch (error) {
      console.error('Error deleting products and variants:', error);
      setLoading(false);
    }
  };

  return (
    <>
      <Modal open={activeInModal} onClose={onClose} size="xs" backdrop="static">
        <Modal.Header>
               <b>Change Status</b>
            </Modal.Header>
        <Modal.Body>
          <RadioGroup
            name="radio-group-inline"
            inline
            value={status}
            onChange={value => setStatus(value)}
          >
            <Radio value="Active">Active</Radio>
            <Radio value="inActive">InActive</Radio>
          </RadioGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={updateProduct} appearance="primary" color="cyan" loading={loading}>
            Update
          </Button>
          <Button onClick={onClose} appearance="subtle" active>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ActiveInacitve;
